module.exports = __webpack_public_path__ + "static/media/artist-rush-album-6.05849aed.jpg";